export default {
  contact: {
    badge: 'Hablemos',
    title: '¿Listo para transformar las operaciones de tu flota?',
    subtitle: 'Estamos aquí para ayudarte a optimizar la gestión de tu flota con tecnología puntera y soporte experto. Hablemos de cómo podemos impulsar tu negocio.',
    badges: {
      freeConsultation: 'Consulta gratuita',
      customSolutions: 'Soluciones a medida',
      expertSupport: 'Soporte experto',
    },
    methodTitle: 'Elige cómo quieres contactarnos',
    methodSub: 'Estamos aquí para ayudarte por varios canales',
    emailUs: 'Escríbenos',
    dropUsALine: 'Escríbenos cuando quieras',
    weGetBack: 'Te responderemos en un máximo de 4 horas',
    callUs: 'Llámanos',
    giveUsACall: 'Llámanos en horario laboral',
    businessHours: 'Lun–Vie de 9:00 a 18:00',
    contactNow: 'Contactar ahora',
    sendMessage: 'Envíanos un mensaje',
    fillForm: 'Rellena el formulario y te responderemos en un máximo de 4 horas en horario laboral.',
    messageSent: 'Mensaje enviado',
    thanksReachingOut: 'Gracias por contactarnos. Te responderemos en un máximo de 4 horas en horario laboral.',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    emailAddress: 'Correo electrónico',
    phoneNumber: 'Teléfono',
    companyName: 'Empresa',
    fleetSize: 'Tamaño de flota',
    subject: 'Asunto',
    message: 'Mensaje',
    submit: 'Enviar mensaje',
    errorGeneric: 'Algo ha ido mal. Por favor, inténtalo de nuevo.',
    placeholders: {
      firstName: 'Tu nombre',
      lastName: 'Tus apellidos',
      email: 'tu@empresa.com',
      phone: '+34 612 345 678',
      company: 'Tu empresa',
      message: 'Cuéntanos tus necesidades...',
    },
    subjects: {
      general: 'Consulta general',
      demo: 'Demo del producto',
      pricing: 'Información de precios',
      support: 'Soporte técnico',
      partnership: 'Colaboración',
      enterprise: 'Solución enterprise',
    },
    fleetSizes: {
      small: '1-10 vehículos',
      medium: '11-50 vehículos',
      large: '51-100 vehículos',
      xl: '101-500 vehículos',
      xxl: 'Más de 500 vehículos',
    },
    whyContactTitle: '¿Por qué contactarnos?',
    whyContactSub: 'Soporte experto y soluciones a medida',
    bottomCtaTitle: '¿Listo para transformar las operaciones de tu flota?',
    bottomCtaSub: 'Únete a más de 100 empresas que confían en Geofleet para la gestión de su flota',
    statsHappyCustomers: 'Clientes satisfechos',
    statsUptime: 'Tiempo de actividad',
    statsSupport: 'Soporte',
    viewPricingPlans: 'Ver planes de precios',
    contactUsNow: 'Contactar ahora',
    whyContact: {
      strategic: { title: 'Soluciones estratégicas', description: 'Estrategias de gestión de flota adaptadas a tu negocio' },
      fast: { title: 'Implementación rápida', description: 'Configuración e incorporación ágiles' },
      expertise: { title: 'Experiencia sectorial', description: 'Años de experiencia en optimización de flotas' },
      success: { title: 'Éxito contrastado', description: 'Más de 100 clientes satisfechos en todo el mundo' },
    },
    page: {
      eyebrow: "Hablemos",
      title: "Habla con el equipo de Geofleet",
      subtitle: "Cuéntanos sobre tu flota y te mostraremos cómo Geofleet reduce costes y entregas tardías.",
      nextTitle: "Qué pasa después",
      steps: {
        review: "Revisamos tus datos y tu flota.",
        call: "Un especialista te llama en menos de 4 horas laborables.",
        demo: "Recibes una demo y precios adaptados a tu operación.",
      },
      bookDirect: "O reserva una llamada directamente",
    },
    form: {
      name: "Nombre completo",
      email: "Email de trabajo",
      company: "Empresa",
      country: "País",
      phone: "Teléfono",
      fleetSize: "¿Cuántos vehículos?",
      message: "¿Algo más que debamos saber?",
      messagePlaceholder: "Rutas, herramientas actuales, qué quieres mejorar…",
      optional: "Opcional",
      submit: "Contactar",
      reassurance: "Respondemos en menos de 4 horas laborables. Sin spam.",
      orEmail: "También puedes escribir a",
      successTitle: "¡Gracias, {{name}}!",
      successBody: "Hemos recibido tus datos y te llamaremos en menos de 4 horas laborables. ¿Prefieres no esperar?",
      bookNow: "Reservar ahora",
      jobTitle: "Cargo",
      jobTitlePlaceholder: "p. ej. Director de Operaciones",
      jobTitles: {
        founder: "Fundador / CEO",
        operations: "Director de Operaciones",
        fleet: "Jefe de Flota",
        logistics: "Jefe de Logística",
        dispatch: "Responsable de Despacho",
        it: "CTO / Responsable de TI",
        procurement: "Compras",
      },
      solutions: "¿Qué estás buscando?",
      pickAny: "Elige varias",
      solutionOptions: {
        route_planning: "Planificación de rutas",
        shipment_tracking: "Seguimiento de envíos",
        fleet_management: "Gestión de flotas",
        gps_tracking: "Rastreo GPS de vehículos",
        auto_dispatch: "Despacho y asignación automática",
        proof_of_delivery: "Prueba de entrega",
        driver_app: "App para conductores",
        customer_notifications: "Seguimiento al cliente y WhatsApp",
        dashcam_safety: "Dashcam y seguridad",
        cash_on_delivery: "Pago contra entrega",
        inventory_hubs: "Inventario y hubs",
        ai_agents: "Agentes de IA y automatización",
        analytics: "Informes y analítica",
        integrations: "Integraciones y API",
      },
      errors: {
        name: "Introduce tu nombre.",
        email: "Introduce un email válido.",
        phone: "Introduce un teléfono válido para {{country}}.",
      },
    },
  },
};
